module.exports = __webpack_public_path__ + "img/heart.a9e20aa2.png";